<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="true"
        class="ah-detail-dialog batch-modify-account-items-dialog"
        top="5vh"
        append-to-body
        :before-close="onBeforeClose"
        :lock-scroll="false"
        @open="onOpen"
    >
        <template slot="title">科目置換</template>

        <!-- 編輯畫面 -->
        <div v-if="status === 'edit'" class="detail-row edit-view">
            <div class="query-section">
                <div class="query-item">
                    <div class="label">傳票日期範圍</div>
                    <ahAccountingDatePicker v-model="dateRange" />
                </div>
                <div class="account-item-selector-section">
                    <div class="query-item">
                        <div class="label">原科目</div>
                        <ah-select-accounting-setting v-model="oldAccno.sno" use-sno @change="onOleAccnoSnoChange" />
                    </div>
                    <i class="el-icon-right" />
                    <div class="query-item">
                        <div class="label">新科目</div>
                        <ah-select-accounting-setting v-model="newAccno.sno" use-sno @change="onNewAccnoSnoChange" />
                    </div>
                </div>
            </div>

            <div v-if="isTableShow" class="table-section">
                <div class="label">將被替換的傳票（共{{ totalDataCount }}筆）</div>
                <el-table :data="datas" v-loading="isLoading" height="40vh" @selection-change="onSelectionChange" @row-click="$emit('row-click', $event)">
                    <el-table-column key="selection" type="selection" width="50"></el-table-column>
                    <el-table-column prop="vono" label="傳票號碼" width="120" />
                    <el-table-column prop="dat" label="傳票日期" width="100">
                        <template slot-scope="scope">
                            <div>{{ scope.row.dat | dateFormater("YYYY-MM-dd") }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="傳票狀態" width="80" align="center">
                        <template slot-scope="scope">
                            <AccountingStatusLabel :statusNum="scope.row.status" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="transactionType" label="帳務類型">
                        <template slot-scope="scope">
                            {{ transactionTypeToName(scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="crD_NTD" label="借方金額" align="right">
                        <template slot-scope="scope">
                            <Money :v="scope.row.crD_NTD" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="deB_NTD" label="貸方金額" align="right">
                        <template slot-scope="scope">
                            <Money :v="scope.row.deB_NTD" />
                        </template>
                    </el-table-column>
                    <el-table-column width="100"></el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination layout="prev, pager, next" :page-size.sync="queryParams.PageSize" :total.sync="totalDataCount" :current-page.sync="queryParams.PageNum" @current-change="updateData">
                    </el-pagination>
                </div>
            </div>

            <div class="btn-section">
                <el-button @click="onCancel">取消</el-button>
                <el-button type="primary" :disabled="isSubmitDisabled" @click="onSubmit">執行置換</el-button>
            </div>
        </div>

        <!-- 確認畫面 -->
        <div v-if="status === 'view'" class="detail-row confirm-view">
            <div class="complete-title">置換完成 {{ selectedItems.length }} 筆傳票</div>
            <div class="complete-transfer-accounting-item-section">
                <div class="block">
                    <div class="label">原科目</div>
                    <div class="value">{{ oldAccno.data.label }}</div>
                </div>
                <i class="el-icon-right" />
                <div class="block">
                    <div class="label">新科目</div>
                    <div class="value">{{ newAccno.data.label }}</div>
                </div>
            </div>

            <div v-if="isTableShow" class="table-section">
                <el-table :data="selectedItems" height="40vh">
                    <el-table-column width="50"></el-table-column>
                    <el-table-column prop="vono" label="傳票號碼" width="120" />
                    <el-table-column prop="dat" label="傳票日期" width="100">
                        <template slot-scope="scope">
                            <div>{{ scope.row.dat | dateFormater("YYYY-MM-dd") }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="傳票狀態" width="80" align="center">
                        <template slot-scope="scope">
                            <AccountingStatusLabel :statusNum="scope.row.status" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="transactionType" label="帳務類型">
                        <template slot-scope="scope">
                            {{ transactionTypeToName(scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="crD_NTD" label="借方金額" align="right">
                        <template slot-scope="scope">
                            <Money :v="scope.row.crD_NTD" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="deB_NTD" label="貸方金額" align="right">
                        <template slot-scope="scope">
                            <Money :v="scope.row.deB_NTD" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="success" align="right" width="100">
                        <!-- eslint-disable-next-line vue/no-unused-vars -->
                        <template slot-scope="scope">
                            <i v-if="scope.row.success" class="el-icon el-icon-check" />
                            <i v-else class="el-icon el-icon-close" />
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="btn-section">
                <el-button @click="onRestart">置換其他科目</el-button>
                <el-button type="primary" @click="onCancel">關閉</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import ahAccountingDatePicker from '@/components/ui/ahAccountingDatePicker.vue';
import ahSelectAccountingSetting from '@/components/ui/ahSelectAccountingSetting.vue';
import AccountingStatusLabel from '@/components/dashboard/Accounting/AccountingSummary/ui/AccountingStatusLabel.vue';

export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        parentDateRange: {
            type: Array,
            default: () => [],
        },
        transactionTypeToName: {
            type: Function,
            default: () => {},
        },
    },
    components: { ahAccountingDatePicker, ahSelectAccountingSetting, AccountingStatusLabel },
    data() {
        return {
            isLoading: false,
            isSubmitting: false,
            dateRange: [],
            queryParams: {
                StartDateStart: null,
                StartDateEnd: null,
                PageSize: 200,
                PageNum: 1,
            },

            oldAccno: { sno: null, data: {} },
            newAccno: { sno: null, data: {} },

            datas: [],
            totalDataCount: 0,

            selectedItems: [],
            status: 'edit',
        };
    },
    computed: {
        isTableShow() {
            return this.dateRange.length && this.oldAccno.sno;
        },
        isSubmitDisabled() {
            return !this.oldAccno.sno || !this.newAccno.sno || !this.selectedItems.length;
        },
        isStartEndDateSameYear() {
            return moment(Number(this.dateRange[0])).year() === moment(Number(this.dateRange[1])).year();
        },
    },
    methods: {
        onOpen() {
            this.dateRange = this.parentDateRange;
        },
        async updateData() {
            if (!this.isStartEndDateSameYear) {
                this.$message({
                    showClose: true,
                    message: '不可跨年度查詢，請重新選擇日期範圍。',
                    type: 'error',
                });
                return;
            }
            this.updateQuery();

            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: 'AccountingSummaryPage/QueryVouchers',
                    method: 'GET',
                    params: { ...this.queryParams, accno: this.oldAccno.data.accno },
                });
                this.datas = resp.data.items;
                this.totalDataCount = resp.data.totalNum;
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        updateQuery() {
            this.queryParams.StartDateStart = Number(_.head(this.dateRange));
            this.queryParams.StartDateEnd = Number(_.last(this.dateRange));
        },
        onBeforeClose() {
            this.$emit('close');
            this.resetForm();
        },
        onSelectionChange(val) {
            this.selectedItems = val;
        },
        onOleAccnoSnoChange(val) {
            this.oldAccno.data = val;
            this.updateData();
        },
        onNewAccnoSnoChange(val) {
            this.newAccno.data = val;
        },
        onCancel() {
            this.$emit('close');
            this.resetForm();
        },
        onRestart() {
            this.resetForm();
            this.updateData();
        },
        resetForm() {
            this.oldAccno = { sno: null, data: {} };
            this.newAccno = { sno: null, data: {} };
            this.selectedItems = [];
            this.status = 'edit';
        },
        async onSubmit() {
            const modifyItems = _.map(this.selectedItems, (o) => ({ vono: o.vono, NowACCNO_SNO: this.oldAccno.sno, newACCNO_SNO: this.newAccno.sno }));

            try {
                this.isSubmitting = true;
                const resp = await this.$api({
                    url: 'AccountingSummaryPage/ModifyAccounts',
                    method: 'POST',
                    data: { modifyItems },
                });

                console.log(this.selectedItems, resp.data.sussceVonos);
                resp.data.sussceVonos.forEach((vono) => {
                    const FOUND = _.find(this.selectedItems, ['vono', vono]);
                    FOUND.success = true;
                });
                this.status = 'view';
            } catch (e) {
                console.log(e);
            } finally {
                this.isSubmitting = false;
            }
        },
    },
};
</script>

<style lang="scss">
.batch-modify-account-items-dialog {
    &.ah-detail-dialog .el-dialog .el-dialog__body {
        padding: 10px 0;
        // background-color: #f4f4f6;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
    }
    .edit-view {
        .account-item-selector-section {
            display: flex;
            align-items: flex-end;
            margin-top: 20px;
            width: 70%;
            .el-icon-right {
                width: 50px;
                text-align: center;
                font-size: 20px;
                margin-bottom: 10px;
            }
            .ah-select-accounting-setting .el-cascader {
                width: 100%;
            }
        }
        .query-section {
            margin-bottom: 40px;
            .query-item {
                flex: 1;
                .label {
                    font-weight: bold;
                    margin-bottom: 5px;
                }
            }
        }
    }
    .confirm-view {
        .complete-title {
            text-align: center;
            font-weight: bold;
            font-size: 18pt;
            margin-bottom: 30px;
        }
        .complete-transfer-accounting-item-section {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 30px;
            padding: 0 50px;
            .el-icon-right {
                text-align: center;
                font-size: 20px;
                width: 100px;
                margin: 0 20px;
            }
            .block {
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            .value {
                font-weight: bold;
            }
        }
        .el-icon {
            font-size: 30px;
            font-weight: 1000;
            &.el-icon-check {
                color: green;
            }
            &.el-icon-close {
                color: red;
            }
        }
    }
    .btn-section {
        margin-top: 20px;
        text-align: center;
    }

    .pagination {
        width: 100%;
        margin: 20px 0;
        display: flex;
        justify-content: center;
    }
}
</style>
